import { Component } from '@angular/core';
import { GlobalService } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-video-section',
  templateUrl: './video-section.component.html',
  styleUrls: ['./video-section.component.scss']
})
export class VideoSectionComponent {
  videoAvailable:boolean = false;
  constructor(private _globalService: GlobalService){
    
  }

  ngOnInit(){
    this._globalService.jobInformation.subscribe((data) => {
      this.videoAvailable = (!data?.pageData?.video?.videoID)?false:true;
    })
  }
 ngAfterViewInit() {
  const modal = document.getElementById('videoModal')!;
  const iframe = document.getElementById('youtubeFrame') as HTMLIFrameElement;

  modal?.addEventListener('show.bs.modal', () => {
    iframe.src = 'https://www.youtube.com/embed/ZE6qZjPqDd4?rel=0&autoplay=1';
  });

  modal?.addEventListener('hidden.bs.modal', () => {
    iframe.src = ''; // Stop video when modal closes
  });
}

}
